/**
 * Feb 2026 — Region hero image manifest.
 *
 * One editorial hero photograph per region. Generated once via
 * Gemini Nano Banana (see /app/backend/scripts/generate_region_hero_images.py)
 * and served from /api/uploads/region-heroes/<slug>.png.
 *
 * Keys are `region.slug` values from `locationTree.js` REGIONS.
 */

export const REGION_HERO_IMAGES = {
  "sunshine-coast": {
    src: "/api/uploads/region-heroes/sunshine-coast.png",
    alt: "Sunshine Coast rural acreage with a rainwater tank and Glasshouse Mountains silhouette on the hazy horizon, subtropical morning light.",
  },
  "northern-rivers": {
    src: "/api/uploads/region-heroes/northern-rivers.png",
    alt: "Northern Rivers NSW hinterland — a corrugated rainwater tank beside a modest farmhouse, emerald sugar-cane paddocks stretching to a wet-season sky.",
  },
  "toowoomba": {
    src: "/api/uploads/region-heroes/toowoomba.png",
    alt: "Darling Downs high country — a windmill-fed bore beside a corrugated tank on a Toowoomba grazing property, black soil paddocks and basalt escarpment behind.",
  },
  "dayboro": {
    src: "/api/uploads/region-heroes/dayboro.png",
    alt: "Dayboro hinterland acreage — a Colorbond rainwater tank beside a Queenslander home, D'Aguilar Range foothills wreathed in soft morning cloud.",
  },
  "redland-bay-logan": {
    src: "/api/uploads/region-heroes/redland-bay-logan.png",
    alt: "Redland Bay foreshore with a modest bayside home, a rainwater tank beside it, and the Moreton Bay islands visible across the sheltered water.",
  },
  "tweed-byron": {
    src: "/api/uploads/region-heroes/tweed-byron.png",
    alt: "Tweed Valley property with the pyramid silhouette of Wollumbin (Mount Warning) dominating the horizon, a large corrugated rainwater tank in the foreground.",
  },
  "central-coast": {
    src: "/api/uploads/region-heroes/central-coast.png",
    alt: "Central Coast NSW coastal-lake fringe — a low-set beach cottage with a rainwater tank, still lake water reflecting an overcast morning sky.",
  },
  "riverina-southern-tablelands": {
    src: "/api/uploads/region-heroes/riverina-southern-tablelands.png",
    alt: "Riverina irrigation country — a farmhouse with a corrugated tank, endless wheat paddocks curving to a dry-season horizon, a lone red gum in the middle distance.",
  },
  "bathurst-central-tablelands": {
    src: "/api/uploads/region-heroes/bathurst-central-tablelands.png",
    alt: "Central Tablelands high country near Bathurst — a corrugated rainwater tank beside a weatherboard farmhouse on a frosty morning, golden poplars and granite sheep paddocks rolling toward Mount Canobolas.",
  },
  "tropical-north-queensland": {
    src: "/api/uploads/region-heroes/tropical-north-queensland.png",
    alt: "Tropical North Queensland — a dark polyethylene rainwater tank beside a raised timber home, dense rainforest canopy and mountain cloud in the wet-tropics background.",
  },
  "gold-coast-south-north": {
    src: "/api/uploads/region-heroes/gold-coast-south-north.png",
    alt: "Gold Coast hinterland property with a slimline rainwater tank, Springbrook plateau ridge line rising behind, subtropical eucalypt canopy and morning haze.",
  },
  "cooloola-fraser-coast": {
    src: "/api/uploads/region-heroes/cooloola-fraser-coast.png",
    alt: "K'gari (Fraser Island) tank-only beach house — a corrugated iron tank beside a raised timber home under she-oak canopy, white sand and clear ocean beyond.",
  },
  "south-gippsland": {
    src: "/api/uploads/region-heroes/south-gippsland.png",
    alt: "South Gippsland dairy country — a rainwater tank beside a weatherboard farmhouse, rolling green pasture and Wilson's Promontory silhouette on the far horizon.",
  },
  "top-end": {
    src: "/api/uploads/region-heroes/top-end.png",
    alt: "Top End tropical savanna — a corrugated iron rainwater tank beside a raised elevated Territory home, paperbark woodland and dramatic build-up storm clouds.",
  },
};

export function hero_for_region(regionSlug) {
  return REGION_HERO_IMAGES[regionSlug] || null;
}
